import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-imposto-renda-pf',
  templateUrl: './imposto-renda-pf.component.html',
  styleUrls: ['./../cadastral-pf/cadastral-pf.component.css','./imposto-renda-pf.component.css']
})
export class ImpostoRendaPfComponent implements OnInit {

  @Input() dados:any;
  public txtButtonConsultar:string='Consultar agora';
  public consultando:Boolean=false;
  public naoSolicitou:Boolean=false;
  public naoEncontrouRegistros:Boolean=false;
  public modalRef:BsModalRef;

  constructor(private modalService:BsModalService) { }
  

  ngOnInit() {
    if(this.dados.irpf===undefined){
      this.naoSolicitou=true;
    }else if(this.dados.irpf===null){
      this.naoEncontrouRegistros=true;
    }
  }
}
